<route lang="yaml">
meta:
  layout: blank
  action: read
  subject: AclDemo
  allowLoggedInOnly: true
</route>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import AgentChat from '@core/components/AgentChat.vue'
import { useUsersStore } from '@/stores'

const usersStore = useUsersStore()
const { myUser } = storeToRefs(usersStore)
const router = useRouter()

const isAdmin = computed(() => myUser.value?.userLevel === 'admin')

// Non-admins should never reach this page; bounce them back to the regular AI page.
if (myUser.value && !isAdmin.value) {
  router.replace('/ai')
}
</script>

<template>
  <AgentChat
    v-if="isAdmin"
    page-mode
    agent-type="admin"
  />
  <div
    v-else
    class="d-flex flex-column align-center justify-center"
    style="min-height: 50vh; padding: var(--ds-space-6);"
  >
    <h2 class="text-h6 mb-2">
      Admin only
    </h2>
    <p class="text-body-2 text-medium-emphasis">
      This page is only available to platform administrators.
    </p>
  </div>
</template>
